import FetchService from "./Shared/FetchService";
import MessageThreadDomainService from "../Domain/MessageThread/MessageThread.service";
const BASE_URL = "/aviso/messageThread";
export default class MessageThreadService {
    static getThreadFromMessage(messageId) {
        return FetchService.getSingleResponse(BASE_URL + "/getThreadFromMessage", {
            messageId,
        }).then(MessageThreadDomainService.fromJSON);
    }
    static getThread(threadId) {
        return FetchService.getSingleResponse(BASE_URL + "/getThread", {
            threadId,
        }).then(MessageThreadDomainService.fromJSON);
    }
    static shouldMessageDefaultAsLogged({ threadId, }) {
        return FetchService.getSingleResponse(BASE_URL + "/shouldMessageDefaultAsLogged", { threadId });
    }
    static advisorReplyToThread({ threadId, body, saveMessageAsNote, noteTypeIds, sourceId, attachmentIds, logMessage, inlineAttachments, }) {
        return FetchService.postSingleResponse(BASE_URL + "/advisorReplyToThread", {
            threadId,
            body,
            saveMessageAsNote,
            noteTypeIds,
            sourceId,
            attachmentIds,
            logMessage,
            inlineAttachments,
        });
    }
}
